import { TextField, TextFieldProps } from "@mui/material";

export interface NumericTextFieldProps extends Omit<TextFieldProps, "type"> {
  step?: string;
}

const NumericTextField = ({
  step,
  inputProps,
  sx,
  ...props
}: NumericTextFieldProps) => {
  return (
    <TextField
      type="number"
      inputProps={{
        step,
        ...inputProps,
      }}
      onWheel={(e) => (e.target as HTMLElement).blur()}
      sx={{ ...sx }}
      {...props}
    />
  );
};

export default NumericTextField;
